(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    (function () {
    // Three accent colors that spiral across the logo as the user scrolls.
    // Keep in sync with the effect's original colors: #66c4fa / #f89cff / #ffa35c
    var COLORS = [
      [102, 196, 250],
      [248, 156, 255],
      [255, 163, 92]
    ];

    function initLogoGradient(canvas) {
      var ctx = canvas.getContext('2d');
      var src = canvas.dataset.logoSrc;
      if (!src) return;

      var img = new Image();
      var ready = false;
      var currentProgress = 0;

      function resize() {
        var rect = canvas.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return false;
        var dpr = window.devicePixelRatio || 1;
        canvas.width = Math.round(rect.width * dpr);
        canvas.height = Math.round(rect.height * dpr);
        return true;
      }

      function drawLogo(scrollProgress) {
        if (!ready) return;
        if (!resize()) return;

        var dpr = window.devicePixelRatio || 1;
        var w = canvas.width / dpr;
        var h = canvas.height / dpr;

        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, w, h);

        ctx.globalCompositeOperation = 'source-over';
        ctx.drawImage(img, 0, 0, w, h);

        var angleRad = scrollProgress * Math.PI * 4;
        var grad;

        if (typeof ctx.createConicGradient === 'function') {
          grad = ctx.createConicGradient(angleRad, w / 2, h / 2);
          grad.addColorStop(0, 'rgb(' + COLORS[0].join(',') + ')');
          grad.addColorStop(0.33, 'rgb(' + COLORS[1].join(',') + ')');
          grad.addColorStop(0.66, 'rgb(' + COLORS[2].join(',') + ')');
          grad.addColorStop(1, 'rgb(' + COLORS[0].join(',') + ')');
        } else {
          grad = ctx.createLinearGradient(0, 0, w, h);
          var i0 = Math.floor(scrollProgress * 3) % 3;
          grad.addColorStop(0, 'rgb(' + COLORS[i0].join(',') + ')');
          grad.addColorStop(0.5, 'rgb(' + COLORS[(i0 + 1) % 3].join(',') + ')');
          grad.addColorStop(1, 'rgb(' + COLORS[(i0 + 2) % 3].join(',') + ')');
        }

        ctx.globalCompositeOperation = 'source-in';
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, w, h);
      }

      // Some themes scroll a wrapper element (e.g. .page-wrapper) on desktop
      // but fall back to native window scroll on mobile. Listen to both and
      // decide, on every event, which one actually has scrollable content.
      var scrollEl = document.querySelector('.page-wrapper');
      var hasWrapper = !!scrollEl && scrollEl !== document.body && scrollEl !== document.documentElement;

      function wrapperIsScrollable() {
        return hasWrapper && (scrollEl.scrollHeight - scrollEl.clientHeight) > 1;
      }

      function getScrollTop() {
        return wrapperIsScrollable() ? scrollEl.scrollTop : window.scrollY;
      }

      function getMaxScroll() {
        return wrapperIsScrollable()
          ? scrollEl.scrollHeight - scrollEl.clientHeight
          : document.documentElement.scrollHeight - window.innerHeight;
      }

      function refresh() {
        var maxScroll = getMaxScroll();
        currentProgress = maxScroll > 0 ? Math.min(getScrollTop() / maxScroll, 1) : 0;
        drawLogo(currentProgress);
      }

      img.onload = function () {
        ready = true;
        refresh();
      };
      img.onerror = function () {
        // Leave the original <img> visible if the canvas source fails to load.
      };
      img.src = src;

      window.addEventListener('scroll', refresh, { passive: true });
      if (hasWrapper) {
        scrollEl.addEventListener('scroll', refresh, { passive: true });
      }
      window.addEventListener('resize', refresh);
      window.addEventListener('load', refresh);
    }

    document.querySelectorAll('[data-logo-gradient]').forEach(initLogoGradient);
  })();
  } catch(e) { console.error(e); }
})();

})();
